// 15 minutes in ms
export const SLEEP_TRANSLATIONS_FETCH = 15 * 60 * 1000
export const BROWSER_TRANSLATIONS_KEY = 'translations'
export const RETRY_TRANSLATIONS_FETCH = 5
